module.exports = __webpack_public_path__ + "img/christmas-logo.de806e5.svg";